/**
 * postMessage protocol for embedding the dashboard via iframe.
 *
 * All messages are namespaced under "losan-dashboard/" so the host page can
 * safely share its window with other iframes.
 *
 * Host pages should validate every outbound message they receive by checking
 * `event.origin` against the iframe's expected origin, AND by checking that
 * `event.data.type` starts with the namespace below.
 */

export const PROTOCOL_NAMESPACE = 'losan-dashboard/';
export const PROTOCOL_VERSION = 1;

/* ---------- Host → Dashboard (inbound) ---------- */

export type InboundMessage =
  | { type: 'losan-dashboard/set-identity'; payload: { agentId: string; token?: string } }
  | { type: 'losan-dashboard/clear-identity' };

/* ---------- Dashboard → Host (outbound) ---------- */

export type OutboundMessage =
  | { type: 'losan-dashboard/ready'; payload: { version: number } }
  | { type: 'losan-dashboard/height'; payload: { height: number } }
  | { type: 'losan-dashboard/identity-changed'; payload: { agentId: string | null } }
  | { type: 'losan-dashboard/error'; payload: { message: string } };

export function isInboundMessage(data: unknown): data is InboundMessage {
  if (!data || typeof data !== 'object') return false;
  const t = (data as { type?: unknown }).type;
  return typeof t === 'string' && t.startsWith(PROTOCOL_NAMESPACE);
}
